import React from "react";
import { FormattedMessage } from "react-intl";

var ForgottenPassword = function ForgottenPassword(_ref) {
  var onClick = _ref.onClick;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "login__content__password-reminder"
  }, React.createElement("p", null, React.createElement(FormattedMessage, {
    id: "components.OverlayManager.Login.ForgottenPassword.1214263298",
    defaultMessage: "Have you forgotten your password?"
  }), " ", React.createElement("span", {
    className: "u-link",
    onClick: onClick,
    "data-test": "accountOverlayForgottenPasswordLink"
  }, React.createElement(FormattedMessage, {
    id: "components.OverlayManager.Login.ForgottenPassword.1781368875",
    defaultMessage: "Click Here"
  })))));
};

export default ForgottenPassword;